export default __webpack_public_path__ + "static/media/poweredByBlackAndWhite.01906352.png";